import React from 'react'
import { sendGamificationEngagement, type FeedItem } from '../../../Api'
import { useAuthContext } from '../../../Context'
import { Right } from '../../Icons'
import { logEvent } from '../../../Utils'
import { HeadlineList } from '../styles'
import { Lk } from '../../Links/Lk'
import { gamificationEngagements } from '../../../Constant/gamification'

type HeadlinesProps = {
  feedItems: FeedItem[]
}

export const Headlines: React.FC<React.PropsWithChildren<HeadlinesProps>> = ({
  feedItems,
}) => {
  const { isLoggedIn, userId } = useAuthContext()

  const log = (event: string, art: FeedItem) => {
    if (isLoggedIn && userId) {
      sendGamificationEngagement(userId, gamificationEngagements.ARTICLE_READ, art.id)
    }
    logEvent(event, {
      page: 'home',
      section: 'headlines',
      article: art.title,
      tags: art.tags,
      article_id: art.id,
    })
  }
  return (
    <HeadlineList>
      {feedItems.map((art, idx) => (
        <li key={idx} className="link">
          <Right />
          <Lk
            link={art.shareLink ? art.shareLink : art.itemLink}
            alt={art.title || art.itemLink}
            onBeforeNavigate={() => log('article_click', art)}
            awaitBeforeNavigate={true}
          >
            <span onClick={() => log('article_click', art)}>{art.title}</span>
          </Lk>
        </li>
      ))}
    </HeadlineList>
  )
}
